import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const WebCustomerSalesList = lazy(() => import('./pages/WebCustomerSalesList'));
const POSCustomerSalesList = lazy(() => import('./pages/POSCustomerSalesList'));
const WebCustomerOrders = lazy(() => import('./pages/WebCustomerOrders'));
const POSCustomerTransactions = lazy(() => import('./pages/POSCustomerTransactions'));

const customerSalesRoutes: RouteObject[] = [
  {
    path: 'customer-sales/web',
    element: <WebCustomerSalesList />,
  },
  {
    path: 'customer-sales/pos',
    element: <POSCustomerSalesList />,
  },
  {
    path: 'customer-sales/web/:customerId',
    element: <WebCustomerOrders />,
  },
  {
    path: 'customer-sales/pos/:customerId',
    element: <POSCustomerTransactions />,
  },
];

export default customerSalesRoutes;
